import type { FC } from "react";

import {
  COLLAPSABLE_CONTENT_VARIANT_CLASS_MAP,
  COLLAPSABLE_TRIGGER_VARIANT_CLASS_MAP,
  COLLAPSIBLE_DEFAULTS,
  type TCollapsibleProps,
} from "@/ui/components/data-display/Collapsible/Collapsible.config";
import {
  CollapsibleContent,
} from "@/ui/components/data-display/Collapsible/CollapsibleContent";
import {
  CollapsibleRoot,
} from "@/ui/components/data-display/Collapsible/CollapsibleRoot";
import {
  CollapsibleTrigger,
} from "@/ui/components/data-display/Collapsible/CollapsibleTrigger";
import { cn } from "@/ui/lib/utils";

export const Collapsible: FC<TCollapsibleProps> = (
  {
    children,
    className,
    contentClassName,
    icon = COLLAPSIBLE_DEFAULTS.icon,
    variant = COLLAPSIBLE_DEFAULTS.variant,
    title,
    triggerClassName,
    ...props
  },
) => (
  <CollapsibleRoot
    data-component="Collapsible"
    className={cn(
      className,
    )}
    {...props}
  >
    <CollapsibleTrigger
      icon={icon}
      className={cn(
        triggerClassName,
        COLLAPSABLE_TRIGGER_VARIANT_CLASS_MAP[variant],
      )}
    >
      { title }
    </CollapsibleTrigger>
    <CollapsibleContent className={cn(
      contentClassName,
      COLLAPSABLE_CONTENT_VARIANT_CLASS_MAP[variant],
    )}>
      { children }
    </CollapsibleContent>
  </CollapsibleRoot>
);

Collapsible.displayName = "Collapsible";
